import { defineRule } from 'vee-validate';

defineRule('passwordMatch', (value: string, [target]: [string]) => {
    if (!value || !target) return true;
    return value === target;
});

defineRule('token', (value: string) => {
    if (!value) return true;
    return value.length === 5;
});

defineRule('minLength', (value: string, [min]: [string]) => {
    if (!value) return true;
    const minLength = parseInt(min, 10);
    return value.length >= minLength;
});

defineRule('maxLength', (value: string, [max]: [string]) => {
    if (!value) return true;
    const maxLength = parseInt(max, 10);
    return value.length <= maxLength;
});

defineRule('length', (value: string, [exact]: [string]) => {
    if (!value) return true;
    const exactLength = parseInt(exact, 10);
    return value.length === exactLength;
});

defineRule('email', (value: string) => {
    if (!value) return true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
});

defineRule('required', (value: any) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') return value.trim() !== '';
    return Boolean(value);
});
